export enum ImageDisplayStatus {
  LOADED = 'loaded',
  ERROR = 'error',
  LOADING = 'loading',
  EMPTY = '',
}
